export default {
    flex: 1,
    sortable: true,
    resizable: true,
    tooltipValueGetter: (params) => params.value,
};
